export const LAST_ACTIVITY_STORAGE_KEY = 'evonik:last-activity';

export interface SessionActivityReadResult {
  storageAvailable: boolean;
  timestamp: number | null;
}

let inMemoryTimestamp: number | null = null;

export const parseSessionActivityTimestamp = (
  value: string | null,
  now: number = Date.now()
): number | null => {
  if (value === null) return null;

  const timestamp = Number(value);
  if (!Number.isFinite(timestamp) || timestamp <= 0 || timestamp > now) {
    return null;
  }

  return timestamp;
};

export const readSessionActivity = (
  now: number = Date.now()
): SessionActivityReadResult => {
  try {
    const storedValue = localStorage.getItem(LAST_ACTIVITY_STORAGE_KEY);

    if (storedValue === null && inMemoryTimestamp !== null) {
      return {
        storageAvailable: false,
        timestamp: inMemoryTimestamp,
      };
    }

    return {
      storageAvailable: true,
      timestamp: parseSessionActivityTimestamp(storedValue, now),
    };
  } catch {
    return {
      storageAvailable: false,
      timestamp: inMemoryTimestamp,
    };
  }
};

export const recordSessionActivity = (timestamp: number): boolean => {
  if (
    !Number.isFinite(timestamp) ||
    timestamp <= 0 ||
    timestamp > Date.now()
  ) {
    return false;
  }

  inMemoryTimestamp = timestamp;

  try {
    localStorage.setItem(LAST_ACTIVITY_STORAGE_KEY, String(timestamp));
    return true;
  } catch {
    return false;
  }
};

export const clearSessionActivity = (): boolean => {
  inMemoryTimestamp = null;

  try {
    localStorage.removeItem(LAST_ACTIVITY_STORAGE_KEY);
    return true;
  } catch {
    return false;
  }
};
